<template>
  <div
    id="bullet"
    :style="`top:${top}px;`"
    @click="insertBullet(el)"
    class="bullet_style"
  >
    <div style="width:420px;" />
    <div
      :id="`bullet-left_${id}`"
      :style="'height:' + (showCount + 2) * eHeight + 'px'"
      class="bullet-left_style"
    />
  </div>
</template>

<script>
import { generateId } from './util.js'
export default {
  props: {
    showCount: {
      type: Number,
      default: 3
    }, // 可展示个数,
    eHeight: {
      type: Number,
      default: 20
    },
    top: {
      type: Number,
      default: 0
    },
    rightTime: {
      type: Number,
      default: 0.58
    },
    bottomTime: {
      type: Number,
      default: 0.58
    }
  },
  data() {
    return {
      id: generateId(),
      count: 1,
      el: this.el,
      t: 'aa'
    }
  },

  methods: {
    insertBullet(el) {
      if (!el || !el.$mount) return
      const maxCount = this.showCount + 2
      const e = document.getElementById(`bullet-left_${this.id}`)
      const vm = el.$mount()
      const eb = vm.$el
      eb.id = `_${this.count}`
      if (e.hasChildNodes()) {
        e.insertBefore(eb, e.firstElementChild)
      } else {
        e.appendChild(eb)
      }

      // eslint-disable-next-line no-unused-expressions
      window.scrollX // render dom in order to repaint page

      for (let i = 0; i < e.childNodes.length; i++) {
        // eslint-disable-next-line standard/computed-property-even-spacing
        e.childNodes[i].style = `transition: right ${this.rightTime}s, bottom ${
          this.bottomTime
        }s, opacity 0.25s;bottom:${(i + 1) * this.eHeight}px;right:${
          i > this.showCount - 1 ? '-400px;opacity: 0;' : '20px;opacity:1;'
        }`
      }

      if (e.childNodes.length > maxCount) {
        e.removeChild(e.childNodes[e.childNodes.length - 1])
      }

      this.count = this.count >= maxCount ? 1 : this.count + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.bullet_style {
  position: fixed;
  right: 0px;
  top: 30%;
}
.bullet-left_style {
  position: relative;
  overflow: hidden;
  max-width: 420px;
}
</style>

<style>
.bullet-left_style > div {
  position: absolute;
  bottom: 0px;
  right: -400px;
  opacity: 0;
}
</style>
